export const PUMP_FUN_LINK =
  "https://pump.fun/21mjzgyVJLox3BjUBMaGGKzKKc8pf1CfbcMytEr8zK7j";
export const TWITTER_LINK = "https://x.com/RugStrikeGame";
export const TELEGRAM_LINK = "https://t.me/rugstrikegame";
